<cdx-slotted-modal *ngIf="activeStep$ | async as step" (close)="handleClose()" size="medium" padding="large" [modalStyle]="modalStyle$ | async" [center]="true" [mobileFullHeight]="isMobileDevice$ | async" [canDismiss]="step.name !== stepName.finalising">
	<div *ngIf="step.name === stepName.splash" class="splash" modal-content>
		<cdx-icon-circle display="inline" name="cutlery" size="huge" background="green"></cdx-icon-circle>
		<h1 i18n="@@choose-meal-plan-splash-heading" class="heading--2 heading--main">Help us recommend meals that you will love</h1>
		<p i18n="@@choose-meal-plan-splash-description">Let's get started with a couple of simple questions</p>
	</div>
	<div *ngIf="step.name === stepName.splash" class="footer-splash" modal-footer-primary>
		<cdx-button (click)="activateStep(stepName.people)" i18n="@@choose-meal-plan-get-started">Get Started</cdx-button>
	</div>

	<div *ngIf="step.name === stepName.people" class="preference" modal-content>
		<ng-container *ngTemplateOutlet="stepIndicator; context: { step }"></ng-container>
		<cdx-icon-circle display="inline" name="buddy" size="medium" background="light-green"></cdx-icon-circle>
		<h1 i18n="@@choose-meal-plan-people-heading" class="heading--2 heading--main">How many people are you feeding?</h1>
		
		<recipe-meal-plan-household-preference
			[adultValue]="step.value?.adult ?? step.default?.adult"
			[childValue]="step.value?.child ?? step.default?.child"
			(increment)="saveStepPeople($event, step)"
			(decrement)="saveStepPeople($event, step)"
		></recipe-meal-plan-household-preference>
	</div>
	<div *ngIf="step.name === stepName.people" class="footer-slot split-buttons" modal-footer-primary>
		<ng-container *ngTemplateOutlet="(isMobileDevice$ | async) ? peopleNextButton : peopleCancelButton"></ng-container>
		<ng-container *ngTemplateOutlet="(isMobileDevice$ | async) ? peopleCancelButton : peopleNextButton"></ng-container>

		<ng-template #peopleCancelButton>
			<button cdxButton fillStyle="flat" (click)="handleClose()" i18n="@@choose-meal-plan-cancel">Cancel</button>
		</ng-template>
		<ng-template #peopleNextButton>
			<button cdxButton type="button" (click)="activateStep(stepName.dietaryNeeds, stepName.people)" i18n="@@choose-meal-plan-next" [disabled]="step.value?.adult === 0 && step.value?.child === 0">Next</button>
		</ng-template>
	</div>

	<div *ngIf="step.name === stepName.dietaryNeeds" class="preference" modal-content>
		<ng-container *ngTemplateOutlet="stepIndicator; context: { step }"></ng-container>
		<cdx-icon-circle display="inline" name="basil" size="medium" background="light-green"></cdx-icon-circle>
		<h1 i18n="@@choose-meal-plan-dietaryNeeds-heading" class="heading--2 heading--main">Any dietary needs?</h1>
		<recipe-meal-plan-dietary-preference
			[value]="(step.value || step.default)[0]"
			[options]="step.options"
			(valueChange)="saveDietaryNeedsStep($event)"
		></recipe-meal-plan-dietary-preference>
	</div>
	<div *ngIf="step.name === stepName.dietaryNeeds" class="footer-slot" modal-footer-primary>
		<ng-container *ngTemplateOutlet="(isMobileDevice$ | async) ? dietaryNeedsNextButton : dietaryNeedsPreviousButton"></ng-container>
		<ng-container *ngTemplateOutlet="(isMobileDevice$ | async) ? dietaryNeedsPreviousButton : dietaryNeedsNextButton"></ng-container>
	
		<ng-template #dietaryNeedsPreviousButton>
			<button cdxButton fillStyle="outline" (click)="activateStep(stepName.people, stepName.dietaryNeeds)" i18n="@@choose-meal-plan-cancel">Previous</button>
		</ng-template>
		<ng-template #dietaryNeedsNextButton>
			<button cdxButton (click)="activateStep(stepName.finalising, stepName.dietaryNeeds, true)" i18n="@@choose-meal-plan-next" [disabled]="step.value?.adult === 0 && step.value?.child === 0">Next</button>
		</ng-template>
	</div>

	<div *ngIf="step.name === stepName.finalising" class="finalising" modal-content>
		<ng-lottie [options]="finalisingAnimationOptions" width="175px" height="175px" [styles]="{ margin: '0 auto' }"></ng-lottie>
		<h1 i18n="@@choose-meal-plan-finalising-heading" class="heading--2 heading--main">Preparing your meal options</h1>
		<p i18n="@@choose-meal-plan-finalising-analysing">Analysing your preferences and household size.</p>
		<p i18n="@@choose-meal-plan-finalising-dont-worry">Don't worry, you can always modify your settings later.</p>
	</div>

</cdx-slotted-modal>

<ng-template #stepIndicator let-step="step">
	<div class="step-indicator heading--2" [attr.aria-label]="'Step ' + step.currentStep + ' of ' + step.totalSteps">{{ step.currentStep }}/{{ step.totalSteps }}</div>
</ng-template>